module.exports = __webpack_public_path__ + "img/empty_avatar.27bc115b.jpg";